import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import "./style/theme.scss"
import App from './App.tsx'
import '@inmagik/magik-ui/style.css'


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
